export default __webpack_public_path__ + "static/media/continental-finance-logo.74d49b74.png";